'use strict';

var framerMotion = require('framer-motion');
var React = require('react');
var _utils = require('./_utils.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const variants = {
    exit: {
        opacity: 0,
        transition: {
            duration: 0.15,
            ease: _utils.EASINGS.easeOut,
        },
    },
    enter: {
        opacity: 1,
        transition: {
            duration: 0.2,
            ease: _utils.EASINGS.easeIn,
        },
    },
};
const fadeConfig = {
    variants,
    initial: 'exit',
    animate: 'enter',
    exit: 'exit',
};
const Fade = React__namespace.forwardRef((props, ref) => {
    const { unmountOnExit, visible, ...rest } = props;
    const show = unmountOnExit ? visible && unmountOnExit : true;
    const motionProps = React__namespace.useMemo(() => ({
        ...fadeConfig,
        animate: visible || unmountOnExit ? 'enter' : 'exit',
    }), [visible, unmountOnExit]);
    return React__namespace.createElement(framerMotion.AnimatePresence, null, show && React__namespace.createElement(framerMotion.motion.div, { ref: ref, ...motionProps, ...rest }));
});
Fade.displayName = 'Fade';

exports.Fade = Fade;
exports.fadeConfig = fadeConfig;
//# sourceMappingURL=Fade.js.map
